import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "../../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-college-document-create",
  templateUrl: "./college-document-create.component.html",
  styleUrls: ["./college-document-create.component.scss"],
})
export class CollegeDocumentCreateComponent implements OnInit {
  public tinyConfig = {
    base_url: '/assets/tinymce',
    suffix: '.min',
    height: 400,
    menubar: true,
    plugins: 'code table link image lists',
    apiKey: '',
    toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | table | link image | code',
  };
  @Input() record: any;          // ✅ data for edit
  @Input() collegeId: string;    // ✅ college id from parent
  @Output() formSaved = new EventEmitter<void>();  // ✅ notify parent
  @Output() cancel = new EventEmitter<void>();     // ✅ cancel event
  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  isShown: boolean = false;
  colleges = null;



  constructor(
    private ActivatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) { }

  public reg = "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?";

  ngOnInit() {
    let role = localStorage.getItem("userRole");
    let user = localStorage.getItem("userId");

    this.action = "Submit";
    this.ActivatedRoute.params.subscribe((params) => {
      let id = params["id"];

      this.http
        .get<any>(`${environment.apiUrl}/collegedocument/${id}`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            console.log(data);

            data.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (data != "") {

              this.action = "Update";


              this.Form.patchValue({
                _id: data._id,
                year: data.year,
                college: data.college,
                name: data.name,
                description: data.description,
                status: data.status,
                document: data.document,

              });
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
      this.http
        .get<any>(`${environment.apiUrl}/college/`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            if (data.message === "Logged Out!") {
              this.router.navigateByUrl("/auth/login");
              return;
            }
            this.colleges = data.results || data;
          },
          (err: HttpErrorResponse) => {
            console.error("Error loading colleges:", err);
          }
        );
      this.http
        .get<any>(`${environment.apiUrl}/collegedocument/bycollegeId?college=${id}`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            console.log(data);
            console.log(data.results);
            console.log(data.results[0].college);

            data.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (data != "") {

              this.action = "Update";


              this.Form.patchValue({
                _id: data._id,
                college: data.results[0].college,
              });
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );

    });

    this.Form = this.formBuilder.group({
      name: ["", [Validators.required]],
      college: ["", Validators.required],
      year: ["", Validators.required],
      status: ["", Validators.required],
      description: ["", Validators.required],
      document: ["", Validators.required],
      _id: [""],
    });
    if (this.record) {
      this.action = "Update";
      this.Form.patchValue(this.record);
    } else {
      this.action = "Submit";
      this.Form.patchValue({ college: this.collegeId });
    }
  }


  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if (this.action == "Submit") {
      let data = {
        name: this.Form.value.name,
        college: this.Form.value.college,
        year: this.Form.value.year,
        description: this.Form.value.description,
        status: this.Form.value.status,
        document: this.Form.value.document,

      };
      console.log(data);

      this.http
        .post<any>(`${environment.apiUrl}/collegedocument/`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(

          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Added";
              this.class = "btn-success rounded px-1 py-1";
              this.router.navigateByUrl("/college-details/college-document-list");
              this.formSaved.emit();   // ✅ emit on success
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    } else {
      let data = {
        name: this.Form.value.name,
        college: this.Form.value.college,
        year: this.Form.value.year,
        description: this.Form.value.description,
        status: this.Form.value.status,
        document: this.Form.value.document,
      };
      console.log(data);
      let id = this.Form.value._id;
      console.log(id);


      this.http
        .patch<any>(`${environment.apiUrl}/collegedocument/${id}`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Updated";
              this.class = "btn-success rounded px-1 py-1";
              this.router.navigateByUrl("/college-details/college-document-list");
              this.formSaved.emit();   // ✅ emit on success
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    }
  }
  onCancel() {
    if (this.cancel.observers.length > 0) {
      // 🔹 Case 1: Opened inside modal (popup)
      this.cancel.emit();
    } else {
      // 🔹 Case 2: Opened as a standalone routed page
      this.router.navigateByUrl("/college-details/college-address-list");
    }
  }
}
